import { CommonActions } from '@react-navigation/native';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import { bindActionCreators } from 'redux';
import config from '../../config';
import I18n from '../../lib/i18n';
import Navigation from '../../lib/navigation';
import { fetchAvailableOptions } from '../../modules/AvailableOption';
import {
  availableServiceOptionsSelector,
  getCreditableOptionsWithPlan,
  getLocalCreditableOptionsWithPlan,
  hasRoamingCreditableOptions,
} from '../../modules/AvailableOption/selectors';
import { isExemptedFromTaxSelector } from '../../modules/Customer/selectors';
import {
  currentSubscriptionDaysLeftSelector,
  currentSubscriptionSelector,
  isLineOFFSelector,
} from '../../modules/Dashboard';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import { resetOfferState } from '../../modules/NewOffer';
import { setNewOffer } from '../../modules/NewOffer/actions';
import {
  isNewOfferSameAsCurrentSelector,
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
} from '../../modules/NewOffer/selectors';
import * as actions from '../../modules/Subscription';
import {
  setCurrentVoucherDetails,
  setVoucherDetailsComeFrom,
  voucherCurrentVoucherDetailsSelector,
  voucherFilteredAvailableVouchersSelector,
} from '../../modules/Voucher';
import ChangePlan from './ChangePlan';

function mapStateToProps(state, ownProps) {
  const isSelectPlanScene = () => {
    return ownProps.navigation?.state?.routeName === 'selectPlan';
  };
  const daysLeft = currentSubscriptionDaysLeftSelector(state);

  return {
    canChangePlanNow: config.canChangePlanNow,
    canEnterVoucher: config.canEnterVoucher,
    creditableOptions: config.displayRoamingPlanSliders
      ? getLocalCreditableOptionsWithPlan(state)
      : getCreditableOptionsWithPlan(state),
    serviceOptions: availableServiceOptionsSelector(state),
    price: newOfferPriceSelector(state),
    periodicity: newOfferPeriodicitySelector(state),
    disableNextButton:
      (isNewOfferSameAsCurrentSelector(state) || !isNewOfferValidSelector(state)) && !isSelectPlanScene(),
    buttonText: daysLeft ? I18n.t('changePlanIn', { count: daysLeft }) : I18n.t('changePlan'),
    confirmModalText: daysLeft ? I18n.t('yourPlanWillChangeIn', { count: daysLeft }) : I18n.t('yourPlanWillChange'),
    isExemptedFromTax: isExemptedFromTaxSelector(state),
    currentSubscription: currentSubscriptionSelector(state),
    isConfirmationLoading: isLoadingSelector(state, 'changePlanConfirmation'),
    currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
    displayVouchersForChangePlan: config.displayVouchersForChangePlan,
    filteredAvailableVouchers: voucherFilteredAvailableVouchersSelector(state),
    isLineOFF: isLineOFFSelector(state),
    hasRoamingOptions: hasRoamingCreditableOptions(state),
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const isSelectPlanScene = () => {
    return ownProps.title === 'selectPlan';
  };

  return {
    setVoucherDetailsComeFrom: (comeFrom: string) => dispatch(setVoucherDetailsComeFrom(comeFrom)),
    setCurrentVoucherDetails: (object: Object) => dispatch(setCurrentVoucherDetails(object)),
    goToConfirmationScene: isSelectPlanScene()
      ? () => Navigation.dispatch(CommonActions.navigate({ name: 'selectPlanConfirmation' }))
      : () => Navigation.dispatch(CommonActions.navigate({ name: 'changePlanConfirmation' })),
    fetchAvailableOptions: () => dispatch(fetchAvailableOptions(true)),
    resetOfferState: () => dispatch(resetOfferState()),
    clearOfferState: () => dispatch(setNewOffer({plan: null, options: [], price: 0, changePlanDate: 'now'})),
    ...bindActionCreators(actions, dispatch),
  };
}
const withOrderTypeProps = (): { orderType: string } => ({
  orderType: 'CHANGEPLAN',
});

export default compose(withProps(withOrderTypeProps()), connect(mapStateToProps, mapDispatchToProps))(ChangePlan);
